import { z } from 'zod';
import { IsoDateTime, PageMeta, PageRequest, MutationReason } from './_common.js';
import { UserTier } from './users.js';
export const CohortCriteria = z.object({
    tier: z.array(UserTier).optional(),
    ban_status: z.array(z.enum(['none', 'temporary', 'permanent'])).optional(),
    has_purchase: z.boolean().optional(),
    is_synthetic: z.boolean().optional(),
    country_code: z.array(z.string().length(2)).optional(),
    last_seen_after: IsoDateTime.optional(),
    last_seen_before: IsoDateTime.optional(),
    created_after: IsoDateTime.optional(),
    created_before: IsoDateTime.optional(),
    tags_any: z.array(z.string()).optional(),
    tags_all: z.array(z.string()).optional(),
    lifetime_iap_cents_min: z.number().int().optional(),
    lifetime_iap_cents_max: z.number().int().optional(),
    game_recently_played: z.string().optional(),
    bracket_id: z.string().optional(),
});
export const CohortDefinition = z.object({
    id: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    criteria: CohortCriteria,
    created_by: z.string(),
    created_at: IsoDateTime,
    last_used_at: IsoDateTime.nullable(),
});
export const CohortCreateRequest = z.object({
    name: z.string().min(2).max(80),
    description: z.string().max(500).nullable().default(null),
    criteria: CohortCriteria,
    reason: MutationReason,
});
export const CohortCreateResponse = CohortDefinition;
export const CohortListRequest = PageRequest.extend({
    q: z.string().optional(),
});
export const CohortListResponse = z.object({
    items: z.array(CohortDefinition),
    page: PageMeta,
});
export const CohortPreviewRequest = z.object({
    criteria: CohortCriteria,
});
export const CohortPreviewResponse = z.object({
    matched_count: z.number().int(),
    sample_user_ids: z.array(z.string()),
});
export const CohortCompensateJobStatus = z.enum(['queued', 'running', 'completed', 'failed', 'cancelled']);
export const CohortCompensateRequest = z.object({
    cohort_id: z.string().nullable(),
    ad_hoc_criteria: CohortCriteria.nullable(),
    amount_per_user: z.number().int().min(1),
    category: z.enum(['bug', 'goodwill', 'event_reward', 'customer_service', 'manual']),
    delivery: z.enum(['ledger_grant', 'gift_inbox']).default('ledger_grant'),
    reason: MutationReason,
});
export const CohortCompensateResponse = z.object({
    job_id: z.string(),
    estimated_users: z.number().int(),
    estimated_total_amount: z.number().int(),
    status: CohortCompensateJobStatus,
});
export const CohortCompensateJobDetail = z.object({
    job_id: z.string(),
    status: CohortCompensateJobStatus,
    cohort_id: z.string().nullable(),
    amount_per_user: z.number().int(),
    delivery: z.enum(['ledger_grant', 'gift_inbox']),
    reason: z.string(),
    category: z.string(),
    created_by: z.string(),
    created_at: IsoDateTime,
    started_at: IsoDateTime.nullable(),
    finished_at: IsoDateTime.nullable(),
    total_users: z.number().int(),
    processed_users: z.number().int(),
    failed_users: z.number().int(),
    total_amount_paid: z.number().int(),
});
export const CohortCompensateCancelRequest = z.object({
    reason: MutationReason,
});
//# sourceMappingURL=cohort.js.map